module.exports = __webpack_public_path__ + "static/deep-water-blues-25bc8bf3c71e44fdf980fac26df58f37.jpg";